import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthProvider";
import { Checkbox } from "@jammable/ui-core";
import axios from "axios";
import PitchSlider2 from "./PitchSlider2";
import VolumeSlider from "./VolumeSlider";
import VoiceImage from "../VoiceImage";
import AutotuneSelector from "./AutotuneSelector";
import CreatorBadge from "../CreatorBadge";
import { getAuth } from "firebase/auth";
import { useRouter } from "next/router";
import toast from "react-hot-toast";
import styles from "../../styles/Conversion.module.css";
import { Spinner } from "@jammable/ui-components/Loader";
import { Button } from "@jammable/ui-core";
import { Input } from "@jammable/ui-components/Forms";
import Tabs from "../../components/Tabs";
import useSubscription from "../../hooks/useSubscription";

const ModelConvertSettings = ({
  /* eslint-disable no-unused-vars */
  model,
  /* eslint-enable no-unused-vars */
  accent,
  speed,
  youtubeUrl,
  text,
  toolMode,
  expression,
  ip,
  finalUrl,
  progress,
  mode,
  setUpgradeModalOpen,
  setIsOpen,
  librarySong,
  title,
  voices,
  setPitchScalingForVoice,
  uploadedFileId,
  metadata,
  gender,
  selectedPreset,
}) => {
  const ready = progress === 100 ? true : false;

  const { user, updateUser } = useAuth();
  const quota = user?.quota;
  const isFree = !quota?.conversions?.hasCredits;
  const [remainingFreeConversions, setRemaniningFreeConversions] = useState(
    quota?.conversions?.remainingFreeCredits,
  );
  const [pitch, setPitch] = useState(0);
  const router = useRouter();
  const [addEffects, setAddEffects] = useState(text ? false : true);
  const [voiceVolume, setVoiceVolume] = useState(0);
  /* eslint-disable no-unused-vars */
  const [error, setError] = useState(null);
  /* eslint-enable no-unused-vars */
  const [loading, setLoading] = useState(false);
  const [extractBackground, setExtractBackground] = useState(false);
  const [highQuality, setHighQuality] = useState(false);
  const [name, setName] = useState(title ?? "");
  const [conversionError, setConversionError] = useState(null);
  const [skipExtraction, setSkipExtraction] = useState(false);
  const [autotune, setAutotune] = useState({
    enabled: false,
    strength: 1,
  });

  const { hasCreatorPlan, hasPowerPlan } = useSubscription();

  const notCreator = !hasCreatorPlan() && !hasPowerPlan();

  // Only include the "Audio Effects" tab if the user's email is test@gmail.com
  const tabsData = [
    { id: "basic", label: "Basic" },
    { id: "advanced", label: "Advanced" },
  ];
  const [selectedTab, setSelectedTab] = useState("basic");

  // Create a state for managing audio effects
  const [localAudioEffects, setLocalAudioEffects] = useState([]);

  return (
    <div className={styles["zoom-in"]}>
      {isFree
        ? null
        : // <div className="tw-w-full tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-3 tw-mb-5">
          //   <div className="tw-font-bold tw-text-base tw-tracking-normal ">
          //     Free Daily Conversions
          //   </div>
          //   <div className="tw-flex tw-gap-2 tw-items-center tw-mb-1">
          //     <FreeConversionLimit
          //       used={quota?.conversions?.usage?.freeUsage?.used}
          //       remaining={remainingFreeConversions}
          //       limit={quota?.conversions?.dailyLimit?.limit}
          //       dark={false}
          //     />
          //   </div>
          // </div>
          null}

      <div className="tw-flex tw-flex-col tw-gap-3">
        {error && <div className="error-message ">{error}</div>}

        {conversionError && (
          <div className="error-message">{conversionError}</div>
        )}
        <div className="tw-w-full tw-flex tw-justify-center">
          <Tabs
            tabs={tabsData}
            selectedTab={selectedTab}
            onTabChange={setSelectedTab}
          />
        </div>
        <div className="tw-p-4  tw-bg-gray-100 tw-rounded-3xl tw-flex tw-flex-col tw-gap-2">
          {selectedTab === "basic" ? (
            <>
              <div className="tw-mb-1 tw-bg-white tw-p-3 tw-rounded-2xl tw-px-4">
                <PitchSlider2
                  pitch={pitch}
                  handlePitchChange={setPitch}
                  voices={voices}
                  setPitchScalingForVoice={setPitchScalingForVoice}
                />
              </div>
              <AutotuneSelector autotune={autotune} setAutotune={setAutotune} />
              <div className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-bg-white tw-p-3 tw-px-3 tw-rounded-2xl">
                <Checkbox
                  checked={addEffects}
                  onCheckedChange={setAddEffects}
                />
                <div
                  onClick={() => {
                    setAddEffects(!addEffects);
                  }}
                >
                  <div className="tw-text-sm tw-font-semibold">
                    Add Post Processing Effects
                  </div>
                  <div className="tw-text-xs tw-text-black/40">
                    Apply a mix of tailored effects to your vocals!
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="tw-mb-1 tw-bg-white tw-p-3 tw-rounded-2xl tw-px-4">
                <VolumeSlider
                  voiceVolume={voiceVolume}
                  setVoiceVolume={setVoiceVolume}
                />
              </div>

              <div className="tw-bg-white tw-rounded-2xl tw-p-3  tw-flex tw-flex-col tw-gap-3">
                <div className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer   tw-rounded-2xl">
                  <Checkbox
                    checked={extractBackground}
                    onCheckedChange={setExtractBackground}
                  />
                  <div
                    onClick={() => {
                      setExtractBackground(!extractBackground);
                    }}
                  >
                    <div className="tw-text-sm tw-font-semibold">
                      Extract Background Vocals
                    </div>
                    <div className="tw-text-xs tw-text-black/40 ">
                      Use this if your original input contains background vocals
                      for a cleaner output.{" "}
                    </div>
                  </div>
                </div>
                <div className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer   tw-rounded-2xl">
                  <Checkbox
                    checked={skipExtraction}
                    onCheckedChange={setSkipExtraction}
                  />
                  <div
                    onClick={() => {
                      setSkipExtraction(!skipExtraction);
                    }}
                  >
                    <div className="tw-text-sm tw-font-semibold">
                      Skip Vocal Extraction
                    </div>
                    <div className="tw-text-xs tw-text-black/40 ">
                      Use this if your original input is already isolated.
                      vocals.
                    </div>
                  </div>
                </div>
                <div className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer    tw-rounded-2xl">
                  <Checkbox
                    checked={highQuality}
                    onCheckedChange={(s) => {
                      if (notCreator) {
                        return false;
                      } else {
                        setHighQuality(s);
                      }
                    }}
                  />
                  <div
                    onClick={() => {
                      if (notCreator) {
                        return false;
                      } else {
                        setHighQuality(!highQuality);
                      }
                    }}
                  >
                    <div className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-gap-1 ">
                      Premium Quality
                      {notCreator && <CreatorBadge className="tw-mb-1" />}
                    </div>
                    <div className="tw-text-xs tw-text-black/40">
                      Use this for a higher bit-rate output file.
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <Input
          aria-label="Optional Conversion Name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
          className="tw-h-12 tw-bg-gray-100 tw-font-light tw-rounded-2xl"
          placeholder="Rename (optional)..."
        />

        <div className="tw-w-full tw-border tw-justify-between tw-flex tw-gap-0.5 tw-border-solid tw-border-gray-200 tw-rounded-full tw-items-center tw-pl-1">
          <div className="tw-flex">
            {voices?.map((voice, index) => {
              return (
                <div key={voice._id} className="tw-flex">
                  <VoiceImage
                    key={voice?._id}
                    model={voice}
                    size={42}
                    className="tw-rounded-full tw-border-2 tw-border-solid tw-border-white"
                    style={{
                      marginLeft: index === 0 ? 0 : -15,
                    }}
                  />
                </div>
              );
            })}
          </div>
          <Button
            onClick={async () => {
              if (loading) {
                return false;
              }

              setLoading(true);
              const auth = getAuth();
              const token = await auth.currentUser.getIdToken();
              axios
                .post(
                  `/api/model/conversion`,
                  {
                    originalUrl: finalUrl ?? "",
                    name: name ?? undefined,
                    youtubeUrl: youtubeUrl ?? undefined,
                    ip: ip ?? undefined,
                    mode: mode ?? undefined,
                    addEffects: addEffects,
                    toolMode: toolMode ?? undefined,
                    extractBackground: extractBackground,
                    text: text ?? undefined,
                    ttsPreset: selectedPreset ?? undefined,
                    expression: expression ?? undefined,
                    voices: voices ?? undefined,
                    accent: accent ?? undefined,
                    speed: speed ?? undefined,
                    highQuality: notCreator
                      ? false
                      : highQuality
                        ? highQuality
                        : undefined,
                    librarySong: librarySong ?? undefined,
                    voiceVolume: voiceVolume ?? undefined,
                    uploadedFileId: uploadedFileId ?? undefined,
                    metadata: metadata ?? undefined,
                    gender: gender ?? undefined,
                    skipExtraction: skipExtraction ?? undefined,
                    autotune: autotune ?? undefined,
                    audioEffects: localAudioEffects ?? undefined,
                  },
                  { headers: { Authorization: token } },
                )
                .then((res) => {
                  setRemaniningFreeConversions(remainingFreeConversions - 1);

                  setTimeout(() => {
                    setLoading(false);
                  }, [2000]);
                  updateUser({
                    credits: isFree ? user.credits : user.credits - 1,
                    quota: {
                      ...user.quota,
                      conversions: {
                        ...user.quota.conversions,
                        remainingFreeCredits:
                          user?.quota?.conversions?.remainingFreeCredits - 1,
                      },
                    },
                  });
                  router.push(`/conversion/${res.data.conversion.shortid}`);
                })
                .catch((err) => {
                  const errorMessage = err?.response?.data?.message;
                  setConversionError(errorMessage);
                  setLoading(false);
                  if (errorMessage === "You are out of credits") {
                    toast.error(`You are out of credits`);
                    router.push(`/pricing`);
                  } else if (
                    errorMessage ===
                    "You need to upgrade to use Text to Speech!"
                  ) {
                    setIsOpen(false);
                    setTimeout(() => {
                      setUpgradeModalOpen(true);
                    }, 400);
                  }
                });
            }}
            className="tw-w-full tw-h-12  tw-font-black tw-rounded-full"
            disabled={!ready || (!finalUrl && mode !== "tts") || loading}
          >
            {!ready ? (
              <div>Uploading... {progress}%</div>
            ) : loading ? (
              <Spinner className="tw-border-white tw-border-3" size={4} />
            ) : (
              <div className="tw-flex tw-flex-col">
                <div>Convert!</div>
                <div className="tw-uppercase tw-text-[10px] tw-text-white/50 tw-tracking-widest tw--mt-1">
                  {voices.length === 6 ? "MAX" : voices.length} Voice
                  {voices.length > 1 && "s"} Selected
                </div>
              </div>
            )}
          </Button>
        </div>

        {!librarySong && (
          <div className="tw-text-sm tw-text-black/40">
            By continuing you confirm that this content is{" "}
            <span style={{ fontWeight: 600, color: "black" }}>
              your original vocals/song
            </span>{" "}
            and does not contain third party copyright material.
          </div>
        )}

        {isFree && (
          <div
            onClick={() => {
              setIsOpen(false);
              setTimeout(() => {
                setUpgradeModalOpen(true);
              }, 400);
            }}
            style={{
              background:
                "linear-gradient(90deg, rgba(140,55,213,1) 0%, rgba(242,79,225,1) 35%, rgba(255,0,0,1) 100%)",
            }}
            className="tw-rounded-full tw-text-center tw-font-light tw-tracking-tight tw-cursor-pointer tw-text-white tw-width-full tw-py-4 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-xl"
          >
            <div className="tw-text-md">join the creator plan...</div>
            <div className="tw-font-black tw-text-2xl">
              Create Unlimited Covers
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModelConvertSettings;
